export class SiteTitle {
  private targets?: Element[] | null;
  private lastKnownScrollPosition = 0;
  private ticking = false;
  private itemHeight?: number = 0;
  private resizeObserver?: ResizeObserver | null;
  constructor() {
    this.init();
  }

  private init() {
    this.cleanup();
    this.targets = Array.from(document.querySelectorAll('#site-title svg'));
    if (this.targets && document.body.classList.contains('home')) {
      this.itemHeight = this.targets.at(0)?.clientHeight;
      document.addEventListener('scroll', this.handleScroll);
      this.resizeObserver = new ResizeObserver(this.handleResize);
      this.resizeObserver.observe(document.body);
      this.handleScroll();
    }
  }

  private cleanup() {
    if (this.targets) {
      document.removeEventListener('scroll', this.handleScroll);
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    this.targets = null;
    this.lastKnownScrollPosition = 0;
    this.ticking = false;
    this.itemHeight = 0;
    this.resizeObserver = null;
  }

  private handleScroll = () => {
    this.lastKnownScrollPosition = window.scrollY;
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.tick(this.lastKnownScrollPosition, this.itemHeight);
        this.ticking = false;
      });
      this.ticking = true;
    }
  };

  private tick(scrollY: number, itemHeight: number = 0) {
    const adjustValue = 20;
    this.targets?.forEach((item, index) => {
      if (index === 0) {
        if (itemHeight + adjustValue < scrollY) {
          item.classList.add('js-float-left');
        } else {
          item.classList.remove('js-float-left');
        }
      }
      if (index === 1) {
        if ((itemHeight + adjustValue) * 2 < scrollY) {
          item.classList.add('js-float-left');
        } else {
          item.classList.remove('js-float-left');
        }
      }
      if (index === 2) {
        if (10 < scrollY) {
          item.classList.add('js-float-left');
        } else {
          item.classList.remove('js-float-left');
        }
      }
    });
  }

  private handleResize = () =>
    // entries: ResizeObserverEntry[]
    {
      this.itemHeight = this.targets?.at(0)?.clientHeight;
    };
}
